var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2397_79138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.412 15.8852C28.5631 15.5476 26.2653 12.7855 25.9843 9.37186C25.9513 8.9711 25.6688 8.66666 25.3333 8.66666C24.9976 8.66666 24.715 8.9711 24.6821 9.37186C24.401 12.7855 22.1033 15.5476 19.2543 15.8852C18.9203 15.9247 18.6666 16.2638 18.6666 16.6667C18.6666 17.0695 18.9203 17.4083 19.2543 17.4478C22.099 17.7851 24.4008 20.5424 24.6821 23.9611C24.715 24.3622 24.9976 24.6667 25.3333 24.6667C25.6688 24.6667 25.9513 24.3622 25.9843 23.9611C26.2656 20.5424 28.5674 17.7851 31.412 17.4478C31.746 17.4083 32 17.0695 32 16.6667C32 16.2638 31.746 15.9247 31.412 15.8852Z",
    fill: "#F9C94D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5297 24.7472C17.2505 24.4941 15.4123 22.4224 15.1875 19.8622C15.1611 19.5617 14.9351 19.3333 14.6667 19.3333C14.3981 19.3333 14.1721 19.5617 14.1457 19.8622C13.9209 22.4224 12.0827 24.4941 9.80351 24.7472C9.53634 24.7769 9.33337 25.0312 9.33337 25.3333C9.33337 25.6355 9.53634 25.8896 9.80351 25.9192C12.0792 26.1722 13.9207 28.2401 14.1457 30.8042C14.1721 31.105 14.3981 31.3333 14.6667 31.3333C14.9351 31.3333 15.1611 31.105 15.1875 30.8042C15.4125 28.2401 17.254 26.1722 19.5297 25.9192C19.7969 25.8896 20 25.6355 20 25.3333C20 25.0312 19.7969 24.7769 19.5297 24.7472Z",
    fill: "#F9C94D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8436 9.68982C13.855 9.26787 10.6382 5.81516 10.2447 1.54816C10.1986 1.04721 9.80301 0.666656 9.33333 0.666656C8.8633 0.666656 8.4677 1.04721 8.42162 1.54816C8.02816 5.81516 4.81129 9.26787 0.822737 9.68982C0.355184 9.7392 0 10.163 0 10.6667C0 11.1703 0.355184 11.5937 0.822737 11.6431C4.80527 12.0647 8.0278 15.5113 8.42162 19.7848C8.4677 20.2861 8.8633 20.6667 9.33333 20.6667C9.80301 20.6667 10.1986 20.2861 10.2447 19.7848C10.6385 15.5113 13.861 12.0647 17.8436 11.6431C18.3111 11.5937 18.6667 11.1703 18.6667 10.6667C18.6667 10.163 18.3111 9.7392 17.8436 9.68982Z",
    fill: "#F9C94D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2397_79138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.2fc6ec5f8876929a0d4c6f891e27d5d2.svg";
export { ForwardRef as ReactComponent };